import {
	format_gen2_addons_for_scenes,
	getAddonStatus,
	hasAddon,
} from 'src/helpers/addons/addon_helpers';
import {
	get_mode,
	is_gen_2,
	isNoRelayPlug,
	tmp_units_from_settings,
	isCctOnlyDevice,
	isRgbwwPm,
} from '../../../../../../helpers/interface_helpers';

import { _init_device_condition } from '../../../../helpers/init_device_conditions';
import { extract_gen_2_input_types } from '../../../../helpers/input_btn_type_helpers';
import { devices_config } from '@devices/index';
import { format } from 'svelte-i18n';
import { get } from 'svelte/store';
import { getExtSensorsSettings } from '../../../../../../helpers/ext_sensor_helpers';
import { BLE_BUTTON_MODELS } from 'src/constants';

// import { getAvaliableBleGateways } from 'src/helpers/ble_devices_helpers';

let $format = get(format);

export const format_title = (item) => {
	switch (item?.type) {
		case 'i18n_string_replace':
			//values contains props for translation
			let _obj = {};
			for (let [k, v] of Object.entries(item.values)) {
				_obj[k] = $format(v) || v;
			}
			return $format(item.title, { values: _obj });

		case 'i18n_num_replace':
			return $format(item.title, { values: item.values });

		default:
			return typeof item?.props?.sensor_name !== 'undefined'
				? $format(item?.title) + ` (${item.props.sensor_name})`
				: $format(item?.title, {
						values: { n: typeof item?.props?.add_info_ind },
					});
	}
};
/** selection list -  available conditons per device - Output state, Input state, Button pressed, Sensor detection (motion)*/
export function selectDeviceConditions(components) {
	if (components.length > 0) {
		return components.map((el) => {
			return {
				title: format_title(el),
				value:
					typeof el.props.add_info_ind !== 'undefined'
						? `${el.props.id}${el.props.add_info_ind}`
						: typeof el.props.input_index !== 'undefined'
							? `${el.props.id}${el.props.input_index}`
							: el.props.id,
				disabled: el?.props?.disabled,
			};
		});
	}
	return [];
}

//---------- HELPERS ---------
const extract_gen_1_relay_btn_type = (settings, type, channel) => {
	switch (type) {
		case 'SHSW-L':
			const { btn1_type, btn2_type } = settings.relays[0];
			return [btn1_type, btn2_type];
		default:
			return [settings.relays[`${channel}`].btn_type];
	}
};

/**
 * Initialize condition components for a device
 * @param {Object} device - The device object
 * @param {Object} status - The device status
 * @param {Object} settings - The device settings
 * @returns {Array} Array of condition components
 */
export const _init_conditions_components = (device, status, settings) => {
	const { id, category, mode } = device;

	let gen = device.gen;
	let btn_type;
	let addOns, meters, hasInputs, adc, extSwitch;
	let ch = id.split('_')[1] || 0;

	/**
	 * Get the actual mode for the device
	 */
	let deviceMode = mode;
	if (status && settings) {
		deviceMode = get_mode(device, status, settings);
	} else if (isCctOnlyDevice(device.type)) {
		/**
		 * For CCT-only devices, if status/settings aren't available, default to 'cct' mode
		 */
		deviceMode = 'cct';
	}

	if (isNoRelayPlug(device?.type)) {
		return _init_device_condition.power_meter(ch);
	}

	switch (category) {
		case 'module':
			/**
			 * Handle module devices that are CCT-only devices (like S3MX) as lights.
			 * These devices are always in CCT mode, so treat them as lights.
			 */
			if (isCctOnlyDevice(device.type)) {
				/**
				 * Treat as light device
				 */
				let btn_type_1, _mode;
				gen = device.gen == 2 ? 2 : 1;

				if (gen == 1) {
					addOns = {};
					addOns['temperature'] = getExtSensorsSettings(device, 'temperature');
					addOns['humidity'] = getExtSensorsSettings(device, 'humidity');
					btn_type_1 = settings?.lights[`${ch}`]?.btn_type;
					_mode = deviceMode || Object.keys(devices_config[device.type].modes)[0];
					return _init_device_condition['light'](
						device.type,
						ch,
						gen,
						_mode,
						btn_type_1 !== undefined ? [btn_type_1] : btn_type_1,
						addOns,
					);
				} else {
					if (hasAddon(device)) {
						addOns = format_gen2_addons_for_scenes(getAddonStatus(device));
					}
					let support_inputs = status
						? Object.keys(status).some((_k) => _k.match(/input:/))
						: false;
					btn_type_1 =
						support_inputs && settings !== undefined
							? [settings[`input:${ch}`]?.type]
							: undefined;
					_mode = 'cct';
					return _init_device_condition['light'](
						device.type,
						ch,
						gen,
						_mode,
						btn_type_1,
						addOns,
					);
				}
			}

			/**
			 * Regular module handling
			 */
			if (status !== undefined) {
				meters = status[`switch:${ch}`]?.apower !== undefined ? true : false;
			} else {
				meters = false;
			}

			hasInputs = status ? Object.keys(status).some((_k) => _k.match(/input:/)) : false;

			if (settings !== undefined) {
				btn_type = settings[`input:${ch}`]?.type || undefined;
			} else {
				btn_type = undefined;
			}

			if (hasAddon(device)) {
				addOns = format_gen2_addons_for_scenes(getAddonStatus(device));
			}

			return (
				_init_device_condition[category](ch, meters, hasInputs, btn_type, deviceMode, addOns) ||
				[]
			);

		case 'relay':
			/**
			 * because we don't know if gen is Number or String
			 */
			if (is_gen_2(device)) {
				if (status !== undefined) {
					meters = status[`switch:${ch}`]?.apower !== undefined ? true : false;
				} else {
					meters = false;
				}

				hasInputs = status ? Object.keys(status).some((_k) => _k.match(/input:/)) : false;
				btn_type = settings ? extract_gen_2_input_types(settings, device?.type, ch) : undefined;
				if (hasAddon(device)) {
					// let _addOns = getAddonStatus(device);
					addOns = format_gen2_addons_for_scenes(getAddonStatus(device)); // {};
				}
			} else {
				addOns = {};
				addOns['temperature'] = getExtSensorsSettings(device, 'temperature');
				addOns['humidity'] = getExtSensorsSettings(device, 'humidity');

				meters = status?.meters;
				hasInputs = status?.inputs ? true : false;
				btn_type = settings
					? extract_gen_1_relay_btn_type(settings, device?.type, ch)
					: undefined;

				adc = settings?.adcs && ch === 0;
				extSwitch = settings?.ext_switch_enable ? settings?.ext_switch : undefined;
			}

			return (
				_init_device_condition[category](
					device.type,
					gen,
					ch,
					meters,
					hasInputs,
					btn_type,
					addOns,
					extSwitch,
					adc,
				) || []
			);

		case 'sensor':
			let observers = [];
			// hide observers temporary
			// if (device.gen === 'GBLE') {
			// 	observers = getAvaliableBleGateways();
			// }

			const sensorFwVersion =
				device?.fwID ?? status?.[`fwversion:${device?.channel ?? ch ?? 0}`]?.version ?? '';

			return _init_device_condition[category](
				device.type,
				device.gen,
				observers,
				settings, // Pass settings for S4SN-0U61X zone detection
				device?.modeType, // Pass for dynamic ordering of conditions for SBDI-003E
				sensorFwVersion, // Pass FW version to gate light-level band conditions (FW-1690 / FE-1174)
			).map((component) => {
				if (component?.props?.id === 'temperature') {
					component.props.character = tmp_units_from_settings(settings);
				}
				return component;
			});

		case 'light':
			let btn_type_1, _mode;

			if (gen == 1) {
				// gen 1 light bulbs do not have inputs (input components)
				// the check below will return undefined for missing button type props
				btn_type_1 = settings?.lights[`${ch}`]?.btn_type;

				_mode = '';
				if (typeof status !== 'undefined' && typeof settings !== 'undefined') {
					_mode = get_mode(device, status, settings);
				} else {
					_mode = Object.keys(devices_config[device.type].modes)[0];
				}

				return _init_device_condition[category](
					device.type,
					gen,
					mode,
					btn_type_1 !== undefined ? [btn_type_1] : btn_type_1,
				);
			} else {
				//gen 2 lights, first start with Wall Dimmer US and prepare possible structure for other lights
				let support_inputs = status
					? Object.keys(status).some((_k) => _k.match(/input:/))
					: false;
				btn_type_1 =
					support_inputs && settings !== undefined
						? [settings[`input:${ch}`]?.type]
						: undefined;

				// check and update it for color bulbs or something like SHRGBW2 for gen 2
				//otherwise irrelevant what is device mode
				_mode = 'light';

				if (device.type === 'SNDC-0D4P10WW') {
					_mode = get_mode(device, status, settings);
					switch (mode) {
						case 'light':
							btn_type_1 = [settings[`input:${device.channel || 0}`]?.type];
							break;
						case 'rgb':
						case 'rgbw':
							btn_type_1 = Object.entries(settings)
								.filter((set) => set[0].match(/input:/))
								.map((set) => {
									return set[1].type;
								});
							break;
						default:
							break;
					}
				}

				// find supported inputs for the given  channel
				if (isRgbwwPm(device.type)) {
					switch (device.mode) {
						case 'light':
							btn_type_1 = [settings[`input:${device.channel || 0}`]?.type];
							break;
						case 'rgb':
						case 'cct':
							btn_type_1 = Object.entries(settings)
								.filter((set) => set[0].match(/input:/))
								.map((set) => {
									return set[1].type;
								});
							break;
						default:
							break;
					}
				} else if (support_inputs && settings !== undefined) {
					btn_type_1 = extract_gen_2_input_types(settings, device.type, ch);
				}

				let addOns;
				if (hasAddon(device)) {
					addOns = format_gen2_addons_for_scenes(getAddonStatus(device)); // {};
				}

				return _init_device_condition[category](
					device.type,
					device.channel,
					gen,
					mode,
					btn_type_1,
					addOns,
					device?.rgbww_profile,
				);
			}

		case 'roller':
			if (hasAddon(device)) {
				let addOns: any = {};
				addOns = format_gen2_addons_for_scenes(getAddonStatus(device)); // {};

				return _init_device_condition[category](gen, device.type, addOns);
			} else {
				return _init_device_condition[category](gen, device.type);
			}

		case 'emeter':
			let alert: boolean | string = false;
			if (device.type === 'SHEM-3') {
				let ts = 20211109;
				//20211109-131251/v1.11.7-g682a0db
				let fw = settings?.fw?.split('/')[0].split('-')[0];

				alert =
					Number(fw) <= ts
						? $format('required_firmware_alert', {
								values: { version: '20211109-131251/v1.11.7-g682a0db' },
							})
						: false;
			}
			if (hasAddon(device)) {
				let addOns: any = {};
				addOns = format_gen2_addons_for_scenes(getAddonStatus(device)); // {};

				return _init_device_condition[category](
					device.type,
					`${ch}`,
					alert,
					device.mode,
					addOns,
				);
			} else {
				return _init_device_condition[category](
					device.type,
					`${ch}`,
					alert,
					device.mode,
					undefined,
				);
			}

		case 'power_meter':
			return _init_device_condition[category](`${ch}`);

		case 'inputs_reader':
			if (BLE_BUTTON_MODELS.includes(device.type)) {
				// remove observers temporary
				// return _init_device_condition[category](
				// device.type, undefined, 0, 'gble', undefined, getAvaliableBleGateways()
				// );
				return _init_device_condition[category](
					device.type,
					undefined,
					device.channel,
					'gble',
					undefined,
					[],
				);
			}
			if (is_gen_2({ gen })) {
				if (settings !== undefined) {
					btn_type = settings[`input:${ch}`]?.type || undefined;
				} else {
					btn_type = undefined;
				}
				let addOns = format_gen2_addons_for_scenes(getAddonStatus(device));

				return _init_device_condition[category](device.type, btn_type, `${ch}`, gen, addOns);
			} else {
				return _init_device_condition[category](
					device.type,
					settings?.inputs[`${ch}`]?.btn_type,
					`${ch}`,
					gen,
				);
			}

		case 'diffuser':
			return _init_device_condition[category](device.type) || [];
		case 'fan':
			return _init_device_condition[category]() || [];
		case 'thermostat':
			return _init_device_condition[category](device.type).map((component) => {
				if (component?.props?.id === 'temperature') {
					component.props.character = tmp_units_from_settings(settings);
				}
				return component;
			});

		default:
			return [];
	}
};
